<template>
    <base-modal
        hide-header
        hide-footer
        size="lg"
    >
        <div class="col-12">
            <h2 class="editor-header">
                {{ drain && drain.id ? $t('storm_sewers.edit_drain') : $t('storm_sewers.add_drain') }}
            </h2>
        </div>

        <div
            class="col-sm-12"
            @click.stop="null"
        >
            <div
                v-if="drain"
                class="col-sm-12 editor-form"
            >
                <h4 class="form-header">
                    {{ $t('street_lights.basic_info') }}
                </h4>
                <div class="row">
                    <div class="col-sm-4">
                        <span class="span-title">{{ $t('storm_sewers.status') }}</span>
                        <select
                            id="lightStatus"
                            v-model="drain.status"
                            class="form-select form-select-sm"
                        >
                            <option :value="null">{{ $t('street_lights.select_status') }}</option>
                            <option v-for="item in getStatusOptions()"
                                    :key="item.value"
                                    :value="item.value"
                            >
                                {{ item.text }}
                            </option>

                            <!-- compatibility for infraequipment statuses, removed for now as switched to conversion -->
                            <!--
                            <option :value="null">
                                {{ $t('street_lights.select_status') }}
                            </option>
                            <option
                                v-for="(option, index) in getStatusOptions"
                                :key="index"
                                :value="option.value"
                            >
                                {{ option.name }}
                            </option>
                            -->
                        </select>
                    </div>
                    <div class="col-sm-4">
                        <span class="span-title">{{ $t('storm_sewers.radius') }}</span>
                        <input
                            id="radius"
                            v-model="drain.radius"
                            type="number"
                            step="any"
                            min="0"
                            class="form-control form-control-sm"
                        >
                    </div>
                    <div class="col-sm-4">
                        <span class="span-title">{{ $t('street_lights.construction_year') }}</span>
                        <input
                            id="lightYear"
                            v-model="drain.construction_year"
                            type="number"
                            min="0"
                            class="form-control form-control-sm"
                        >
                    </div>
                </div>
                <div class="row px-1">
                    <div class="col-sm-4 p-1">
                        <span class="span-title">{{ $t('storm_sewers.material') }}</span>
                        <select
                            id="material"
                            v-model="drain.material"
                            class="form-select form-select-sm sm-3"
                        >
                            <option :value="null">
                                {{ $t('road_sign.select_material') }}
                            </option>
                            <option
                                v-for="item in getMaterialOptions()"
                                :key="item.value"
                                :value="item.value"
                            >
                                {{ item.text }}
                            </option>
                        </select>
                    </div>
                    <div v-if="isLouhiDrain" class="col-sm-4 p-1">
                        <span class="span-title">{{ $t('storm_sewers.type_sewer_type') }}</span>
                        <select
                            id="sewerLineType"
                            v-model="drain.sewer_type_id"
                            class="form-select form-select-sm"
                        >
                            <option
                                value=""
                                disabled
                            >
                                {{ $t('storm_sewers.type_select_type') }}
                            </option>
                            <option
                                v-for="option in getSewerTypeOptions()"
                                :key="option.value"
                                :value="option.value"
                            >
                                {{ option.text }}
                            </option>
                        </select>
                    </div>
                </div>
                <hr>
                <h4 class="form-header mt-0 pt-0">
                    {{ $t('power_stations.contract') }}
                </h4>
                <span class="tip-light">{{ $t('storm_sewers.contract_tip') }}</span>
                <open-contract-filter
                    v-if="!isLouhiDrain"
                    :to="toDate"
                    :from="fromDate"
                    :contract="contract"
                    :show-company="false"
                    :show-title="false"
                    @loading="loading=true"
                    @loading-completed="loading=false"
                    @contract-selected="setContract"
                />
                <louhi-multiple-contracts-filter
                    v-if="isLouhiDrain"
                    v-model="drainContracts"
                    :editable="!loading"
                    :show-only-louhi-contracts="true"
                    style="margin-left: -2px; margin-right: -3px;"
                    @loading="loading = true"
                    @loading-completed="loading = false"
                    @contract-selected="setContract"
                />
                <hr>
                <div
                    v-if="!isLouhiDrain"
                    class="col-12"
                >
                    <div class="col-12 d-flex justify-content-between align-items-center pb-1">
                        <div class="flex-grow-1">
                            <h4
                                class="form-header pointer hover-header"
                                @click.stop="maintenanceVisible = !maintenanceVisible"
                            >
                                {{ $t('street_lights.maintenance_info') }}
                            </h4>
                        </div>
                        <div
                            class="ms-2 px-2"
                            @click.stop="maintenanceVisible = !maintenanceVisible"
                        >
                            <font-awesome-icon
                                icon="arrow-down"
                                class="pointer no-focus arrow-icon dont-print hover-header"
                                :class="{ rotated: maintenanceVisible }"
                            />
                        </div>
                    </div>
                    <div
                        class="routa-collapse"
                        :class="{ collapsed: maintenanceVisible }"
                    >
                        <div class="col-12">
                            <span class="span-title">{{ $t('street_lights.last_maintenance') }}</span>
                            <input
                                v-model="drain.last_maintenance"
                                type="date"
                                class="form-control form-control-sm"
                            >
                        </div>
                        <div class="col-12">
                            <span class="span-title">{{ $t('street_lights.info') }}</span>
                            <textarea
                                id="info"
                                v-model="drain.maintenance_info"
                                class="form-control form-control-sm"
                                :placeholder="$t('street_lights.info')"
                                rows="4"
                            />
                        </div>
                    </div>
                    <hr>
                </div>
                <h4 class="form-header mt-0 pt-0">
                    {{ $t('street_lights.info') }}
                </h4>
                <div class="col-12">
                    <textarea
                        id="info"
                        v-model="drain.info"
                        :placeholder="$t('street_lights.info')"
                        rows="4"
                        class="form-control"
                    />
                    <hr>
                </div>
                <!-- Attachments-->
                <div v-if="!isLouhiDrain">
                    <h4 class="form-header">{{ $t('orders.attachments_and_info')}}</h4>
                    <div v-if="drain.attachments && drain.attachments.length">
                        <span class="span-title">{{ $t('common.attachments') }}</span>
                        <ol>
                            <li class="pointer"
                                v-for="item in drain.attachments"
                                :key="item.id">
                                <span v-on:click="downloadAttachment(item)">{{ item.file_original_name }}</span>
                                <button
                                    class="btn btn-sm btn-danger mb-1 ml-3 p-0 pl-1 pr-1"
                                    style="width: 1.6em; margin-left: 1em"
                                    @click.stop="removeExistingAttachment(item)"
                                >
                                    <i class="fa fa-trash" style="font-size: .8em; padding: 0; line-height: 1em;"/>
                                </button>
                            </li>
                        </ol>
                    </div>
                    <!-- Attachment upload-->
                    <div>
                        <div
                            v-for="(file, index) in attachments"
                            :key="index"
                            class="d-flex align-items-center justify-content-between mb-3"
                        >
                            <span>{{ file?.name || file }}</span>
                            <button
                                class="btn btn-outline-danger btn-sm"
                                type="button"
                                @click="removeAttachment(index)"
                            >
                                {{ $t('common.remove') }}
                            </button>
                        </div>

                        <input
                            ref="fileInput"
                            type="file"
                            :accept="getValidAttachmentTypes()"
                            class="visually-hidden"
                            @change="handleFileChange"
                        />

                        <div class="col-12 d-flex justify-content-end">
                            <button
                                class="btn btn-outline-primary btn-sm"
                                type="button"
                                @click="triggerFileInput"
                            >
                                {{ $t('work_assignment.add_attachment') }}
                            </button>
                        </div>
                    </div>
                    <hr/>
                </div>
                <div class="col-sm-12 d-flex justify-content-end">
                    <button
                        class="btn btn-secondary form-button"
                        @click.stop="$emit('close')"
                    >
                        {{ $t('common.cancel') }}
                    </button>
                    <button
                        class="btn btn-success form-button"
                        :disabled="loading"
                        @click.stop="submit"
                    >
                        {{ $t('common.save') }}
                    </button>
                </div>
            </div>
            <div
                v-if="loading"
                id="loader"
                class="spinner"
            />
        </div>
    </base-modal>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'
import BaseModal from '../BaseModal'
import LouhiMultipleContractsFilter from "@/components/contract/external/LouhiMultipleContractsFilter.vue";
import OpenContractFilter from "@/components/contract/OpenContractFilter";
import {stormSewersMixin} from "@/components/mixins/StormSewersMixin";
import {timeUtils} from "@/components/mixins/TimeUtils";
import {attachmentHelper} from '@/components/mixins/AttachmentMixin';
import {infraEquipmentHelper} from "@/components/mixins/InfraEquipmentMixin.js";
import {userHelper} from "@/components/mixins/UserMixin";
import {inject} from "vue";

export default {
    name: 'DrainWizard',
    components: {OpenContractFilter, BaseModal, LouhiMultipleContractsFilter},
    mixins: [restApi, timeUtils, stormSewersMixin, attachmentHelper, infraEquipmentHelper, userHelper],
    props: {
        selectedContract: {
            type: Object,
            default: null
        },
        stormDrain: {
            type: Object,
            default: null
        },
        user: {
            type: Object,
            default: null
        }
    },
    emits: ['close', 'closeAndUpdate'],
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert')
        return { showAlert }
    },
    data: function () {
        return {
            loading: false,
            drain: null,
            contract: null,
            attachments: [],
            maintenanceVisible: false,
            variant: 'danger',

            drainContracts: [],
            statusOptions: [
                {value: 1, text: this.$t('storm_sewers.status_ok')},
                {value: 10, text: this.$t('storm_sewers.status_defect')},
                {value: 20, text: this.$t('storm_sewers.status_removed')},
            ],
        }
    },
    computed: {
        //commented out for now, as returning back to routa definitions and creating conversions
      /*  getStatusOptions() {
            return infraEquipmentHelper.methods.getInfraEquipmentStatus.call(this)
        },*/
        fromDate() {
            if (this.drain && this.drain.created_at) {
                return this.drain.created_at
            }
            let d = new Date()
            return d.toISOString()
        },
        toDate() {
            let d = new Date()
            return d.toISOString()
        },
        preselectedContract() {
            return this.drain && this.drain.contract ? this.light.contract : null
        },
        isLouhiDrain() {
            if (this.drain && this.drain.id) {
                //existing
                return this.drain.external_system === 2
            } else {
                //creating new
                return this.hasLouhiInfra(this.user)
            }
        }
    },
    mounted() {
        this.drain = JSON.parse(JSON.stringify(this.stormDrain))
        this.drain.last_maintenance = this.drain.last_maintenance ? this.timestampToDateInput(this.drain.last_maintenance) : null
        this.contract = this.drain.contract ? this.drain.contract : null
        this.drainContracts = this.drain.contracts ? this.drain.contracts : null
        if (this.drain.sewer_type_id === undefined || this.drain.sewer_type_id == null) {this.drain.sewer_type_id = ''}
        if(this.drain && this.drain.id && this.drain.id > 0 && !this.isLouhiDrain) {
            this.fetchDrainAttachments()
        }


    },
    methods: {
        getValidAttachmentTypes() {
            return '.jpg,.jpeg,.png,.pdf,.doc,.docx';
        },
        triggerFileInput() {
            this.$refs.fileInput.click();
        },
        handleFileChange(event) {
            const file = event.target.files[0];
            if (file) {
                this.attachments.push(file);
                event.target.value = ''; // Clear input so same file can be re-selected
            }
        },
        removeAttachment(index) {
            this.attachments.splice(index, 1);
        },
        submit: function () {
            this.loading = true
            if (this.contract) {
                this.drain.contract = this.contract
            }
            this.drain = this.convertPositionToXY(this.drain)
            if(this.isLouhiDrain) {
                const selectedIds = this.normalizeIds(this.drainContracts)
                this.drain.contract_ids = selectedIds
            }
            //attachments
            if(this.drain.id) {
                this.restUpdate(this.stormDrainUrl, this.drain, this.success, this.fail)
            } else {
                this.restAdd(this.stormDrainUrl, this.drain, this.success, this.fail)
            }
        },
        fetchDrainAttachments() {
            this.loading = true
            this.restFetch(this.stormDrainUrl + "/attachments/" + this.drain.id, this.successFetchAttachments, this.failFetchAttachments)
        },
        successFetchAttachments(response) {
            this.loading = false
            if(response !== null) {
                this.drain.attachments = response.data
            }
        },
        failFetchAttachments() {
            this.loading = false
            this.showAlert(this.$t('common.error'))
        },
        downloadAttachment: function (item) {
            this.loading = true
            this.restFetch(this.stormDrainUrl + "/attachment/" + this.drain.id + '/' + item.id,
                response => {
                    this.saveFile(item.file_original_name, response.data)
                    this.loading = false
                }, () => {
                    this.loading = false
                })
        },


        removeExistingAttachment: function (item) {
            if(this.drain.attachments && this.drain.attachments.length > 0) {
                var index = this.drain.attachments.findIndex(attachment => attachment.id === item.id)
                if(index >= 0) {
                    this.drain.attachments.splice(index, 1)
                }
            }
        },
        success: function () {
            this.loading = false
            this.uploadAttachment()
        },
        uploadAttachment: function () {
            let attachments = this.getValidAttachments(this.attachments)
            if (attachments.length > 0) {
                let formData = new FormData()
                attachments.forEach(file => {
                    if (file !== undefined && file !== null) {
                        formData.append('attachments[]', file)
                    }
                })
                this.restPostWithFile(this.stormDrainUrl + "/attachment/" + this.drain.id, {}, formData,
                    () => {
                        this.loading = false
                        this.showAlert(this.$t('common.alert_update_success'), 'success')
                        this.$emit('closeAndUpdate')
                    }, this.fail
                )
            } else {
                this.loading = false
                this.showAlert(this.$t('common.alert_update_success'), 'success')
                this.$emit('closeAndUpdate')
            }
        },
        fail: function () {
            this.loading = false
            this.showAlert(this.$t('common.alert_add_failed'))
        },
        setContract: function (contract) {
            this.contract = contract
        },

    }
}
</script>
<style>
@import "../../styles/modal.css";
</style>
